if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() { super(); }
    hide() { super.hide(); }
    show(opener) {
      super.show(opener);
      this.setupGalleryNavigation();
      this.showActiveMedia();
    }
    setupGalleryNavigation() {
      if (this.galleryControls) return;
      this.galleryContainer = this.querySelector('[role="document"]');
      this.galleryItems = Array.from(this.galleryContainer.children).filter(item => item.hasAttribute('data-media-id'));
      const controls = document.createElement('div');
      controls.className = 'nz-gallery-navigation';
      controls.setAttribute('role', 'group');
      ['click', 'pointerup', 'mouseup', 'touchend'].forEach(type => controls.addEventListener(type, event => event.stopPropagation()));
      controls.setAttribute('aria-label', 'Fotoğraf geçişleri');
      controls.style.cssText = 'position:fixed;left:50%;bottom:12px;transform:translateX(-50%);display:flex;align-items:center;gap:12px;z-index:6;background:white;border:1px solid #ddd;border-radius:28px;padding:5px 9px;box-shadow:0 2px 12px #0001';
      const previous = document.createElement('button');
      previous.type = 'button'; previous.textContent = '←'; previous.setAttribute('aria-label', 'Önceki fotoğraf');
      const counter = document.createElement('span');
      counter.style.cssText = 'font:14px Arial,sans-serif;min-width:48px;text-align:center;color:#25231f';
      counter.setAttribute('aria-live', 'polite');
      const next = document.createElement('button');
      next.type = 'button'; next.textContent = '→'; next.setAttribute('aria-label', 'Sonraki fotoğraf');
      [previous, next].forEach(button => { button.style.cssText = 'width:42px;height:36px;border:0;border-radius:20px;background:#f3f0eb;color:#25231f;font-size:24px;cursor:pointer;display:flex;align-items:center;justify-content:center'; });
      previous.addEventListener('click', () => this.goToGalleryItem(this.galleryIndex - 1));
      next.addEventListener('click', () => this.goToGalleryItem(this.galleryIndex + 1));
      controls.append(previous, counter, next);
      this.querySelector('[role="dialog"]').append(controls);
      this.galleryControls = controls; this.galleryCounter = counter; this.galleryPrevious = previous; this.galleryNext = next;
      controls.hidden = this.galleryItems.length < 2;
      this.galleryContainer.addEventListener('scroll', () => {
        cancelAnimationFrame(this.galleryScrollFrame);
        this.galleryScrollFrame = requestAnimationFrame(() => this.syncGalleryPosition());
      }, { passive: true });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.goToGalleryItem(this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }
    syncGalleryPosition() {
      const container = this.galleryContainer;
      const centre = container.getBoundingClientRect().left + container.clientWidth / 2;
      let closest = 0, distance = Infinity;
      this.galleryItems.forEach((item, index) => {
        const bounds = item.getBoundingClientRect();
        const gap = Math.abs(bounds.left + bounds.width / 2 - centre);
        if (gap < distance) { distance = gap; closest = index; }
      });
      this.galleryIndex = closest;
      this.galleryCounter.textContent = (closest + 1) + ' / ' + this.galleryItems.length;
      this.galleryPrevious.disabled = closest === 0;
      this.galleryNext.disabled = closest === this.galleryItems.length - 1;
    }
    goToGalleryItem(index, instant = false) {
      index = Math.max(0, Math.min(this.galleryItems.length - 1, index));
      const item = this.galleryItems[index];
      if (!item) return;
      this.galleryItems.forEach(media => media.classList.toggle('active', media === item));
      const container = this.galleryContainer;
      const left = container.scrollLeft + item.getBoundingClientRect().left - container.getBoundingClientRect().left - (container.clientWidth - item.getBoundingClientRect().width) / 2;
      container.scrollTo({ left: Math.max(0, left), behavior: instant ? 'instant' : 'smooth' });
      this.galleryIndex = index;
      this.galleryCounter.textContent = (index + 1) + ' / ' + this.galleryItems.length;
      this.galleryPrevious.disabled = index === 0;
      this.galleryNext.disabled = index === this.galleryItems.length - 1;
      if (item.nodeName === 'DEFERRED-MEDIA') item.loadContent();
    }
    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const index = this.galleryItems.findIndex(item => item.getAttribute('data-media-id') === id);
      this.goToGalleryItem(index < 0 ? 0 : index, true);
    }
  });
}
